"use client";

import { m, useScroll, useSpring } from "framer-motion";

export default function ReadingProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 100, damping: 30, restDelta: 0.001 });

  return (
    <m.div
      className="fixed top-0 left-0 right-0 h-[3px] bg-violet-600 origin-left z-[100]"
      style={{ scaleX }}
    />
  );
}
